module.exports = __webpack_public_path__ + "img/logo.8bbc895f.png";